// extracted by mini-css-extract-plugin
export var leftAlign = "_p-2";
export var popper = "_p-0";
export var subtitle = "_p-1";